import React from "react";
import { Card, Button, Typography, Alert } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "Common/Footer";

const { Title, Paragraph } = Typography;

const TrainingAndDevelopment = () => {
  const lmsBaseUrl = process.env.REACT_APP_BASE_URL_LMS;

  const handleNavigateToLMS = () => {
    window.open(lmsBaseUrl, "_blank");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="body flex-grow-1 px-3">
        <Card className="card-professional">
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <Title level={2}>Training & Development</Title>
            <Paragraph style={{ fontSize: "16px", color: "#666" }}>
              All training materials and courses are available on our Learning Management System
            </Paragraph>
          </div>

         <Alert
  message="External Training Platform"
  description="Click the button below to access our dedicated Learning Management System for all training needs."
  type="success" // Changed from info to success
  showIcon
  style={{ 
    marginBottom: "30px", 
    borderRadius: "8px",
    border: "1px solid #b7eb8f", // Soft green border
    backgroundColor: "#f6ffed"   // Very light green background
  }}
/>

          <div style={{ textAlign: "center", padding: "40px 20px" }}>
            <Button
  className="btn-primary"
  size="large"
  icon={<LinkOutlined />}
  onClick={handleNavigateToLMS}
  style={{
    padding: "0 40px",
    height: "50px",
    fontSize: "16px",
    background: "linear-gradient(135deg, #6ac8aa 0%, #284b06 100%)", // Professional Green
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 14px 0 rgba(16, 185, 129, 0.39)", // Subtle green shadow
  }}
>
  Go to Training Platform
</Button>

            <Paragraph style={{ marginTop: "20px", color: "#999", fontSize: "14px" }}>
              Redirecting to: {lmsBaseUrl}
            </Paragraph>
          </div>
        </Card>
      </div>
      <Footer />
    </DashboardLayout>
  );
};

export default TrainingAndDevelopment;
